import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ColorItemComponent } from './color-item.component';
import { ColorPickerComponent } from './color-picker.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ColorItemComponent,
    ColorPickerComponent
  ],
  exports: [
    ColorPickerComponent
  ]
})
export class ColorPickerModule {
}
